import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

export const RenewButton = ({ policy }) => {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const days = Math.ceil((new Date(`${policy.expiry_date}T00:00:00`) - new Date()) / 86400000);
  if (policy.status !== "active" || policy.renewed_by || days > 45) return null;
  const renew = async () => {
    setBusy(true);
    try {
      await api.post(`/policies/${policy.id}/renew`);
      toast.success("Renewal price ready. Choose how to pay in My account.");
      nav("/dashboard");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button onClick={renew} disabled={busy} className="bg-emerald-600 text-white hover:bg-emerald-700" data-testid="renew-policy-btn">
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <RefreshCw className="mr-2 h-4 w-4" />} Renew policy ({Math.max(days, 0)} days left)
    </Button>
  );
};
